import styled from 'styled-components'

import {
  fontSizeValue,
  space4,
  space8,
  space12,
  space16,
  space20,
} from 'core/styles'

// Local layout constants (component tokens) — the only place spacing
// primitives may be referenced; styled-components consume these
export const rowPaddingX = space8
export const rowPaddingY = space12
// rowPaddingY + rowLineHeight + rowPaddingY equals the 40px row height Table
// uses, so a single-line row reaches it symmetrically rather than by stretching
// against a min-height and leaving all the slack below the text.
export const rowLineHeight = '16px'
// The height of an outline TextInput: 1px border + 6px padding + a ~17px line
// box for 14px text + 6px padding + 1px border. A label beside a control uses
// this as its line box so the two texts share a centre line. Recompute it if
// fontSizeInput or the outline padding changes.
export const controlLineHeight = '31px'
export const sectionGap = space20
export const blockGap = space8
export const controlGap = space16
export const microGap = space4

export const ViewModeText = styled.div<{ $color?: string; $muted?: boolean }>`
  word-break: break-word;
  color: ${(p) => p.$color || (p.$muted ? p.theme.labelText : p.theme.text)};
  font-family: Inter, Heebo, sans-serif;
  font-size: ${fontSizeValue};
`
